import shared from "../../data/js/shared";

const {
  adoptionHowItWorksHeading,
  adoptionStep1,
  adoptionStep2,
  adoptionStep3,
  adoptionFeeNote,
} = shared.product;

const AdoptionDetails = () => {
  const steps = [adoptionStep1, adoptionStep2, adoptionStep3];

  return (
    <div className="adoption-details same-color-border">
      <h4 className="adoption-details-heading">{adoptionHowItWorksHeading}</h4>
      <ol className="adoption-details-steps">
        {steps.map((step, index) => (
          <li key={index}>
            <span className="adoption-details-step-number">{index + 1}</span>
            <span className="adoption-details-step-text">{step}</span>
          </li>
        ))}
      </ol>
      <p className="adoption-fee-note">{adoptionFeeNote}</p>
    </div>
  );
};

export default AdoptionDetails;
